// Impl of CanActivate of Angular

import { Injectable, inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  GuardResult,
  MaybeAsync,
  Router,
  RouterStateSnapshot
} from "@angular/router";
import {QdmService} from "../Services/qdm.service";

@Injectable({
  providedIn: 'root'
})
export class RestaurantNeedToBeSelected implements CanActivate {
  private router = inject(Router);
  private qdmService = inject(QdmService);


  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> {
    const redirect = this.router.createUrlTree([""]);
    let isSelected = false;

    this.qdmService.selectedRestaurant$.subscribe((restaurant) => {
      isSelected = !!restaurant;
    });


    return isSelected ? true : redirect;
  }

  redirectToLogin(): void {
  }
}
